(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('delivery-option', {
            parent: 'entity',
            url: '/delivery-option',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.delivery_option.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/delivery-option/delivery-options.html',
                    controller: 'Delivery_optionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery_option');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('delivery-option-detail', {
            parent: 'delivery-option',
            url: '/delivery-option/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.delivery_option.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/delivery-option/delivery-option-detail.html',
                    controller: 'Delivery_optionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delivery_option');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Delivery_option', function($stateParams, Delivery_option) {
                    return Delivery_option.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'delivery-option',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('delivery-option-detail.edit', {
            parent: 'delivery-option-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option/delivery-option-dialog.html',
                    controller: 'Delivery_optionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery_option', function(Delivery_option) {
                            return Delivery_option.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery-option.new', {
            parent: 'delivery-option',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option/delivery-option-dialog.html',
                    controller: 'Delivery_optionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                costo_unitario: null,
                                max_buoni: null,
                                descrizione: null,
                                desctizione_costi: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('delivery-option', null, { reload: 'delivery-option' });
                }, function() {
                    $state.go('delivery-option');
                });
            }]
        })
        .state('delivery-option.edit', {
            parent: 'delivery-option',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option/delivery-option-dialog.html',
                    controller: 'Delivery_optionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Delivery_option', function(Delivery_option) {
                            return Delivery_option.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery-option', null, { reload: 'delivery-option' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('delivery-option.delete', {
            parent: 'delivery-option',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/delivery-option/delivery-option-delete-dialog.html',
                    controller: 'Delivery_optionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Delivery_option', function(Delivery_option) {
                            return Delivery_option.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('delivery-option', null, { reload: 'delivery-option' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
